import React from "react";
import { Filter as RaFilter, SelectInput } from "react-admin";
import SearchInput from "../components/inputs/SearchInput";
import { useFiltersStyles } from "../components/lists/useStyles";

const Filters = (props) => {
	const classes = useFiltersStyles();
	return (
		<RaFilter {...props} classes={classes}>
			<SearchInput source="q" alwaysOn fullWidth variant="outlined" />
			<SelectInput
				source="not_readed"
				label="resources.notifications.fields.readed.empty"
				alwaysOn
				variant="outlined"
				choices={[
					{ id: true, name: "ra.action.yes" },
					{ id: false, name: "ra.action.no" },
				]}
				allowEmpty
				emptyText="ra.action.all"
			/>
		</RaFilter>
	);
};
export default Filters;
